"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgSimcard(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M11 4h9.172a2 2 0 011.414.586l8.828 8.828A2 2 0 0131 14.828V34a2 2 0 01-2 2H11a2 2 0 01-2-2V6a2 2 0 012-2z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("rect", { x: 13, y: 18, width: 14, height: 14, rx: 3, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M13 24h14M22 24v8M27 28h-5", stroke: "currentColor", strokeWidth: 2 }, void 0)] }), void 0));
}
exports.default = SvgSimcard;
//# sourceMappingURL=Simcard.js.map